module.exports = __webpack_public_path__ + "img/reservation-active.37a2c5c2.png";